'use strict';

module.exports = require('./components/inputs/DatePicker').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/DatePicker.js
// module id = 1878
// module chunks = 0